<template>
  <div id="app">
    <el-container>
      <el-header style="display: flex; justify-content: center; align-items: center; height: 60px; background-color: #409EFF; color: #fff; font-size: 24px;">
        <a href="/pdf.pdf" target="_blank" style="color: #fff;">混淆转换对照/点我跳转说明文档</a>
      </el-header>
      <el-main>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header">
                <div style="margin-bottom: 10px">
                  <p>请输入请求参数或者响应数据</p>
                  <p>1.支持json</p>
                  <p>2.支持回车换行的文本</p>
                </div>
                <div>
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="国家">
                      <el-select v-model="formInline.region" @change="regionOnChange">
                        <el-option label="智利" value="1"></el-option>
                        <el-option label="厄瓜" value="2"></el-option>
                        <el-option label="秘鲁" value="3"></el-option>
                        <el-option label="阿根廷" value="4"></el-option>
                        <el-option label="危地马拉" value="5"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="方案">
                      <el-select v-model="formInline.plan">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="reqToMapJson">转换</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <el-input
                type="textarea"
                :rows="20"
                v-model="textareaReqParams">
              </el-input>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
                <span>转换前</span>
              </div>
              <div>
                <json-viewer :value="jsonDataReqBefore" :expand-depth=5 copyable></json-viewer>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
                <span>转换后</span>
              </div>
              <div>
                <json-viewer :value="jsonDataReq" :expand-depth=5 copyable></json-viewer>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      options: [],
      options1: [
          {
            value: '1',
            label: 'PlataListo 混淆'
          }, 
          {
            value: '2',
            label: 'PlataListo 反混淆'
          },
          {
            value: '3',
            label: 'crediplus 混淆'
          },
          {
            value: '4',
            label: 'crediplus 反混淆'
          },
          {
            value: '5',
            label: 'RapiRapa 混淆'
          },
          {
            value: '6',
            label: 'RapiRapa 反混淆'
          },
          {
            value: '7',
            label: 'Andipeso 混淆'
          },
          {
            value: '8',
            label: 'Andipeso 反混淆'
          },
          {
            value: '9',
            label: 'Monticredi 混淆'
          },
          {
            value: '10',
            label: 'Monticredi 反混淆'
          },
          {
            value: '11',
            label: 'Vindadinero 混淆'
          },
          {
            value: '12',
            label: 'Vindadinero 反混淆'
          },
          {
            value: '13',
            label: 'OroSuerte 混淆'
          },
          {
            value: '14',
            label: 'OroSuerte 反混淆'
          },
          {
            value: '15',
            label: 'Cuentasoles 混淆'
          },
          {
            value: '16',
            label: 'Cuentasoles 反混淆'
          },
          {
            value: '17',
            label: 'CrediMaster 混淆'
          },
          {
            value: '18',
            label: 'CrediMaster 反混淆'
          },
          {
            value: '19',
            label: 'Saba 混淆',
            reverse:1,
          },
          {
            value: '20',
            label: 'Saba 反混淆',
            reverse:2,
          },
          {
            value: '21',
            label: 'BanacrediCl 混淆',
            reverse:1,
          },
          {
            value: '22',
            label: 'BanacrediCl 反混淆',
            reverse:2,
          },
      ],
      options2: [
          {
            value: '1',
            label: 'Banapreta 混淆'
          },
          {
            value: '2',
            label: 'Banapreta 反混淆'
          },
          {
            value: '3',
            label: 'Atomomo 混淆'
          },
          {
            value: '4',
            label: 'Atomomo 反混淆'
          },
          {
            value: '5',
            label: 'Saba 混淆',
            reverse:1,
          },
          {
            value: '6',
            label: 'Saba 反混淆',
            reverse:2,
          },
          {
            value: '7',
            label: 'AtomomoX 混淆',
            reverse:1,
          },
          {
            value: '8',
            label: 'AtomomoX 反混淆',
            reverse:2,
          },
      ],
      options3: [
          {
            value: '1',
            label: 'MonkFast 混淆'
          },
          {
            value: '2',
            label: 'MonkFast 反混淆'
          },
          {
            value: '3',
            label: 'MiraFast 混淆'
          },
          {
            value: '4',
            label: 'MiraFast 反混淆'
          },
          {
            value: '5',
            label: 'MoniGoYa 混淆'
          },
          {
            value: '6',
            label: 'MoniGoYa 反混淆'
          },
          {
            value: '7',
            label: 'Orcredi 混淆',
            reverse:1,
          },
          {
            value: '8',
            label: 'Orcredi 反混淆',
            reverse:2,
          },
          {
            value: '9',
            label: 'HeyCredi 混淆',
            reverse:1,
          },
          {
            value: '10',
            label: 'HeyCredi 反混淆',
            reverse:2,
          },
          {
            value: '11',
            label: 'OroyPlata 混淆',
            reverse:1,
          },
          {
            value: '12',
            label: 'OroyPlata 反混淆',
            reverse:2,
          },
          {
            value: '13',
            label: 'Banacredi PE 混淆',
            reverse:1,
          },
          {
            value: '14',
            label: 'Banacredi PE 反混淆',
            reverse:2,
          },
          {
            value: '15',
            label: 'Pego PE 混淆',
            reverse:1,
          },
          {
            value: '16',
            label: 'Pego PE 反混淆',
            reverse:2,
          },
          {
            value: '17',
            label: 'Credxpe PE 混淆',
            reverse:1,
          },
          {
            value: '18',
            label: 'Credxpe PE 反混淆',
            reverse:2,
          },
          {
            value: '19',
            label: 'PlataOne PE 混淆',
            reverse:1,
          },
          {
            value: '20',
            label: 'PlataOne PE 反混淆',
            reverse:2,
          },
          {
            value: '21',
            label: 'Montolibre PE 混淆',
            reverse:1,
          },
          {
            value: '22',
            label: 'Montolibre PE 反混淆',
            reverse:2,
          },
          {
            value: '23',
            label: 'DineFlexYa PE 混淆',
            reverse:1,
          },
          {
            value: '24',
            label: 'DineFlexYa PE 反混淆',
            reverse:2,
          },
      ],
      options4: [
          {
            value: '1',
            label: 'Mokfask 混淆',
            reverse:1,
          },
          {
            value: '2',
            label: 'Mokfask 反混淆',
            reverse:2,
          },
          {
            value: '3',
            label: 'BanacrediAr 混淆',
            reverse:1,
          },
          {
            value: '4',
            label: 'BanacrediAr 反混淆',
            reverse:2,
          },
          {
            value: '5',
            label: 'Saba 混淆',
            reverse:1,
          },
          {
            value: '6',
            label: 'Saba 反混淆',
            reverse:2,
          },
          {
            value: '7',
            label: 'AtomomoX 混淆',
            reverse:1,
          },
          {
            value: '8',
            label: 'AtomomoX 反混淆',
            reverse:2,
          },
          {
            value: '9',
            label: 'ToCredi 混淆',
            reverse:1,
          },
          {
            value: '10',
            label: 'ToCredi 反混淆',
            reverse:2,
          },
          {
            value: '11',
            label: 'RapiLuka AR 混淆',
            reverse:1,
          },
          {
            value: '12',
            label: 'RapiLuka AR 反混淆',
            reverse:2,
          },
          {
            value: '13',
            label: 'Pitage AR 混淆',
            reverse:1,
          },
          {
            value: '14',
            label: 'Pitage AR 反混淆',
            reverse:2,
          },
          {
            value: '15',
            label: 'Cuentasoles AR 混淆',
            reverse:1,
          },
          {
            value: '16',
            label: 'Cuentasoles AR 反混淆',
            reverse:2,
          },
          {
            value: '17',
            label: 'Meda AR 混淆',
            reverse:1,
          },
          {
            value: '18',
            label: 'Meda AR 反混淆',
            reverse:2,
          },
          {
            value: '19',
            label: 'CashiCashi AR 混淆',
            reverse:1,
          },
          {
            value: '20',
            label: 'CashiCashi AR 反混淆',
            reverse:2,
          },
          {
            value: '21',
            label: 'Dacash AR 混淆',
            reverse:1,
          },
          {
            value: '22',
            label: 'Dacash AR 反混淆',
            reverse:2,
          },
          {
            value: '23',
            label: 'Voda AR 混淆',
            reverse:1,
          },
          {
            value: '24',
            label: 'Voda AR 反混淆',
            reverse:2,
          },
          {
            value: '25',
            label: 'Atodidi AR 混淆',
            reverse:1,
          },
          {
            value: '26',
            label: 'Atodidi AR 反混淆',
            reverse:2,
          },
          {
            value: '27',
            label: 'ArgCash AR 混淆',
            reverse:1,
          },
          {
            value: '28',
            label: 'ArgCash AR 反混淆',
            reverse:2,
          },
          {
            value: '29',
            label: 'ArgDin AR 混淆',
            reverse:1,
          },
          {
            value: '30',
            label: 'ArgDin AR 反混淆',
            reverse:2,
          },
          {
            value: '31',
            label: 'MoviCredi AR 混淆',
            reverse:1,
          },
          {
            value: '32',
            label: 'MoviCredi AR 反混淆',
            reverse:2,
          },
          {
            value: '33',
            label: 'TeBanco AR 混淆',
            reverse:1,
          },
          {
            value: '34',
            label: 'TeBanco AR 反混淆',
            reverse:2,
          },
          {
            value: '35',
            label: 'AlToqueCred AR 混淆',
            reverse:1,
          },
          {
            value: '36',
            label: 'AlToqueCred AR 反混淆',
            reverse:2,
          },
          {
            value: '37',
            label: 'MoviCrediIOS AR 混淆',
            reverse:1,
          },
          {
            value: '38',
            label: 'MoviCrediIOS AR 反混淆',
            reverse:2,
          },
      ],
      options5: [
          {
            value: '1',
            label: 'Saba GT混淆',
            reverse:1,
          },
          {
            value: '2',
            label: 'Saba GT反混淆',
            reverse:2,
          },
          {
            value: '3',
            label: 'Voda GT 混淆',
            reverse:1,
          },
          {
            value: '4',
            label: 'Voda GT 反混淆',
            reverse:2,
          },
          {
            value: '5',
            label: 'AtomomoX GT 混淆',
            reverse:1,
          },
          {
            value: '6',
            label: 'AtomomoX GT 反混淆',
            reverse:2,
          },
          {
            value: '7',
            label: 'Credxgt GT 混淆',
            reverse:1,
          },
          {
            value: '8',
            label: 'Credxgt GT 反混淆',
            reverse:2,
          },
          {
            value: '9',
            label: 'DineFast GT 混淆',
            reverse:1,
          },
          {
            value: '10',
            label: 'DineFast GT 反混淆',
            reverse:2,
          },
          {
            value: '11',
            label: 'Xplata GT 混淆',
            reverse:1,
          },
          {
            value: '12',
            label: 'Xplata GT 反混淆',
            reverse:2,
          },
      ],
      textareaReqParams:"",
      jsonDataReqBefore:{},
      jsonDataReq:{},
      reqFormat:{},
      formatMap1:{
        "1":{
          "A":"S","B":"Q","C":"B","D":"R","E":"J","F":"C","G":"V","H":"W","I":"U","J":"X","K":"Z","L":"N","M":"O","N":"D","O":"I","P":"H","Q":"P","R":"T","S":"A","T":"M","U":"F","V":"L","W":"K","X":"Y","Y":"G","Z":"E","a":"y","b":"q","c":"d","d":"m","e":"g","f":"e","g":"i","h":"l","i":"r","j":"x","k":"j","l":"b","m":"c","n":"s","o":"v","p":"z","q":"n","r":"p","s":"f","t":"w","u":"t","v":"a","w":"u","x":"o","y":"h","z":"k"
        },
        "2":{
          "S":"A","Q":"B","B":"C","R":"D","J":"E","C":"F","V":"G","W":"H","U":"I","X":"J","Z":"K","N":"L","O":"M","D":"N","I":"O","H":"P","P":"Q","T":"R","A":"S","M":"T","F":"U","L":"V","K":"W","Y":"X","G":"Y","E":"Z","y":"a","q":"b","d":"c","m":"d","g":"e","e":"f","i":"g","l":"h","r":"i","x":"j","j":"k","b":"l","c":"m","s":"n","v":"o","z":"p","n":"q","p":"r","f":"s","w":"t","t":"u","a":"v","u":"w","o":"x","h":"y","k":"z"
        },
        "3":{
          "A":"B","B":"I","C":"G","D":"Z","E":"S","F":"N","G":"K","H":"D","I":"E","J":"X","K":"Q","L":"V","M":"Y","N":"F","O":"J","P":"L","Q":"O","R":"M","S":"P","T":"H","U":"U","V":"T","W":"W","X":"C","Y":"A","Z":"R","a":"o","b":"j","c":"v","d":"i","e":"g","f":"q","g":"z","h":"l","i":"m","j":"p","k":"r","l":"h","m":"d","n":"e","o":"w","p":"s","q":"a","r":"t","s":"k","t":"f","u":"b","v":"x","w":"c","x":"n","y":"y","z":"u"
        },
        "4":{
          "B":"A","I":"B","G":"C","Z":"D","S":"E","N":"F","K":"G","D":"H","E":"I","X":"J","Q":"K","V":"L","Y":"M","F":"N","J":"O","L":"P","O":"Q","M":"R","P":"S","H":"T","U":"U","T":"V","W":"W","C":"X","A":"Y","R":"Z","o":"a","j":"b","v":"c","i":"d","g":"e","q":"f","z":"g","l":"h","m":"i","p":"j","r":"k","h":"l","d":"m","e":"n","w":"o","s":"p","a":"q","t":"r","k":"s","f":"t","b":"u","x":"v","c":"w","n":"x","y":"y","u":"z"
        },
        "5":{
          "A":"L","B":"F","C":"U","D":"G","E":"E","F":"N","G":"M","H":"Q","I":"D","J":"V","K":"I","L":"X","M":"H","N":"K","O":"T","P":"Y","Q":"S","R":"Z","S":"J","T":"C","U":"W","V":"A","W":"O","X":"R","Y":"B","Z":"P","a":"f","b":"h","c":"k","d":"n","e":"u","f":"z","g":"b","h":"l","i":"p","j":"d","k":"i","l":"e","m":"g","n":"c","o":"w","p":"r","q":"q","r":"x","s":"o","t":"j","u":"y","v":"t","w":"v","x":"s","y":"a","z":"m"
        },
        "6":{
          "L":"A","F":"B","U":"C","G":"D","E":"E","N":"F","M":"G","Q":"H","D":"I","V":"J","I":"K","X":"L","H":"M","K":"N","T":"O","Y":"P","S":"Q","Z":"R","J":"S","C":"T","W":"U","A":"V","O":"W","R":"X","B":"Y","P":"Z","f":"a","h":"b","k":"c","n":"d","u":"e","z":"f","b":"g","l":"h","p":"i","d":"j","i":"k","e":"l","g":"m","c":"n","w":"o","r":"p","q":"q","x":"r","o":"s","j":"t","y":"u","t":"v","v":"w","s":"x","a":"y","m":"z"
        },
        "7":{
          "A":"I","B":"Y","C":"L","D":"T","E":"F","F":"K","G":"M","H":"E","I":"U","J":"O","K":"Q","L":"H","M":"A","N":"P","O":"C","P":"N","Q":"J","R":"R","S":"X","T":"S","U":"D","V":"W","W":"G","X":"V","Y":"Z","Z":"B","a":"m","b":"w","c":"i","d":"k","e":"q","f":"v","g":"s","h":"u","i":"n","j":"x","k":"p","l":"z","m":"g","n":"a","o":"h","p":"t","q":"c","r":"r","s":"l","t":"d","u":"o","v":"f","w":"b","x":"e","y":"j","z":"y"
        },
        "8":{
          "I":"A","Y":"B","L":"C","T":"D","F":"E","K":"F","M":"G","E":"H","U":"I","O":"J","Q":"K","H":"L","A":"M","P":"N","C":"O","N":"P","J":"Q","R":"R","X":"S","S":"T","D":"U","W":"V","G":"W","V":"X","Z":"Y","B":"Z","m":"a","w":"b","i":"c","k":"d","q":"e","v":"f","s":"g","u":"h","n":"i","x":"j","p":"k","z":"l","g":"m","a":"n","h":"o","t":"p","c":"q","r":"r","l":"s","d":"t","o":"u","f":"v","b":"w","e":"x","j":"y","y":"z"
        },
        "9":{
          "A":"U","B":"I","C":"Y","D":"X","E":"T","F":"F","G":"G","H":"N","I":"Q","J":"C","K":"J","L":"E","M":"S","N":"P","O":"D","P":"A","Q":"B","R":"H","S":"W","T":"R","U":"K","V":"L","W":"V","X":"O","Y":"M","Z":"Z","a":"g","b":"r","c":"f","d":"y","e":"x","f":"z","g":"a","h":"i","i":"t","j":"b","k":"e","l":"j","m":"u","n":"k","o":"o","p":"v","q":"l","r":"s","s":"w","t":"n","u":"c","v":"d","w":"h","x":"p","y":"m","z":"q"
        },
        "10":{
          "U":"A","I":"B","Y":"C","X":"D","T":"E","F":"F","G":"G","N":"H","Q":"I","C":"J","J":"K","E":"L","S":"M","P":"N","D":"O","A":"P","B":"Q","H":"R","W":"S","R":"T","K":"U","L":"V","V":"W","O":"X","M":"Y","Z":"Z","g":"a","r":"b","f":"c","y":"d","x":"e","z":"f","a":"g","i":"h","t":"i","b":"j","e":"k","j":"l","u":"m","k":"n","o":"o","v":"p","l":"q","s":"r","w":"s","n":"t","c":"u","d":"v","h":"w","p":"x","m":"y","q":"z"
        },
        "11":{
          "a":"z","b":"u","c":"y","d":"l","e":"c","f":"b","g":"m","h":"n","i":"s","j":"k","k":"f","l":"r","m":"w","n":"t","o":"x","p":"i","q":"q","r":"e","s":"v","t":"g","u":"o","v":"p","w":"h","x":"j","y":"a","z":"d","A":"V","B":"N","C":"K","D":"D","E":"F","F":"Z","G":"H","H":"E","I":"B","J":"G","K":"W","L":"J","M":"S","N":"U","O":"R","P":"Y","Q":"T","R":"O","S":"M","T":"P","U":"Q","V":"C","W":"I","X":"X","Y":"L","Z":"A"
        },
        "12":{
          "z":"a","u":"b","y":"c","l":"d","c":"e","b":"f","m":"g","n":"h","s":"i","k":"j","f":"k","r":"l","w":"m","t":"n","x":"o","i":"p","q":"q","e":"r","v":"s","g":"t","o":"u","p":"v","h":"w","j":"x","a":"y","d":"z","V":"A","N":"B","K":"C","D":"D","F":"E","Z":"F","H":"G","E":"H","B":"I","G":"J","W":"K","J":"L","S":"M","U":"N","R":"O","Y":"P","T":"Q","O":"R","M":"S","P":"T","Q":"U","C":"V","I":"W","X":"X","L":"Y","A":"Z"
        },
        "13":{
          "a":"g","b":"k","c":"w","d":"z","e":"v","f":"t","g":"d","h":"j","i":"e","j":"f","k":"s","l":"x","m":"q","n":"b","o":"l","p":"u","q":"p","r":"y","s":"h","t":"o","u":"r","v":"m","w":"c","x":"a","y":"i","z":"n","A":"F","B":"E","C":"W","D":"C","E":"Z","F":"Q","G":"U","H":"K","I":"M","J":"D","K":"P","L":"L","M":"V","N":"G","O":"X","P":"N","Q":"Y","R":"A","S":"T","T":"J","U":"S","V":"I","W":"H","X":"O","Y":"B","Z":"R"
        },
        "14":{
          "g":"a","k":"b","w":"c","z":"d","v":"e","t":"f","d":"g","j":"h","e":"i","f":"j","s":"k","x":"l","q":"m","b":"n","l":"o","u":"p","p":"q","y":"r","h":"s","o":"t","r":"u","m":"v","c":"w","a":"x","i":"y","n":"z","F":"A","E":"B","W":"C","C":"D","Z":"E","Q":"F","U":"G","K":"H","M":"I","D":"J","P":"K","L":"L","V":"M","G":"N","X":"O","N":"P","Y":"Q","A":"R","T":"S","J":"T","S":"U","I":"V","H":"W","O":"X","B":"Y","R":"Z"
        },
        "15":{
          "a":"e","b":"d","c":"c","d":"a","e":"w","f":"t","g":"l","h":"s","i":"b","j":"y","k":"z","l":"p","m":"h","n":"u","o":"k","p":"o","q":"j","r":"r","s":"q","t":"n","u":"v","v":"m","w":"f","x":"g","y":"x","z":"i","A":"M","B":"R","C":"K","D":"U","E":"N","F":"Y","G":"B","H":"W","I":"J","J":"H","K":"Q","L":"V","M":"O","N":"P","O":"F","P":"S","Q":"A","R":"T","S":"E","T":"Z","U":"X","V":"I","W":"C","X":"G","Y":"D","Z":"L"
        },
        "16":{
          "e":"a","d":"b","c":"c","a":"d","w":"e","t":"f","l":"g","s":"h","b":"i","y":"j","z":"k","p":"l","h":"m","u":"n","k":"o","o":"p","j":"q","r":"r","q":"s","n":"t","v":"u","m":"v","f":"w","g":"x","x":"y","i":"z","M":"A","R":"B","K":"C","U":"D","N":"E","Y":"F","B":"G","W":"H","J":"I","H":"J","Q":"K","V":"L","O":"M","P":"N","F":"O","S":"P","A":"Q","T":"R","E":"S","Z":"T","X":"U","I":"V","C":"W","G":"X","D":"Y","L":"Z"
        },
        "17":{
          "a":"p","b":"b","c":"x","d":"i","e":"h","f":"f","g":"o","h":"j","i":"m","j":"a","k":"k","l":"t","m":"z","n":"c","o":"r","p":"e","q":"g","r":"v","s":"y","t":"u","u":"n","v":"l","w":"s","x":"q","y":"d","z":"w","A":"F","B":"D","C":"V","D":"L","E":"G","F":"X","G":"M","H":"B","I":"T","J":"H","K":"O","L":"E","M":"I","N":"U","O":"K","P":"N","Q":"Z","R":"P","S":"C","T":"Q","U":"W","V":"R","W":"J","X":"Y","Y":"S","Z":"A"
        },
        "18":{
          "p":"a","b":"b","x":"c","i":"d","h":"e","f":"f","o":"g","j":"h","m":"i","a":"j","k":"k","t":"l","z":"m","c":"n","r":"o","e":"p","g":"q","v":"r","y":"s","u":"t","n":"u","l":"v","s":"w","q":"x","d":"y","w":"z","F":"A","D":"B","V":"C","L":"D","G":"E","X":"F","M":"G","B":"H","T":"I","H":"J","O":"K","E":"L","I":"M","U":"N","K":"O","N":"P","Z":"Q","P":"R","C":"S","Q":"T","W":"U","R":"V","J":"W","Y":"X","S":"Y","A":"Z"
        },
        "19":'{"A->Y","B->J","C->W","D->U","E->X","F->R","G->T","H->E","I->G","J->K","K->F","L->V","M->L","N->I","O->H","P->O","Q->S","R->B","S->C","T->A","U->D","V->Q","W->P","X->Z","Y->N","Z->M","a->m","b->l","c->d","d->i","e->r","f->k","g->g","h->b","i->a","j->x","k->e","l->h","m->n","n->c","o->y","p->q","q->s","r->v","s->z","t->t","u->w","v->o","w->j","x->f","y->u","z->p"}',
        "20":'{"A->Y","B->J","C->W","D->U","E->X","F->R","G->T","H->E","I->G","J->K","K->F","L->V","M->L","N->I","O->H","P->O","Q->S","R->B","S->C","T->A","U->D","V->Q","W->P","X->Z","Y->N","Z->M","a->m","b->l","c->d","d->i","e->r","f->k","g->g","h->b","i->a","j->x","k->e","l->h","m->n","n->c","o->y","p->q","q->s","r->v","s->z","t->t","u->w","v->o","w->j","x->f","y->u","z->p"}',
        "21":'{"A->H","B->R","C->A","D->Y","E->G","F->C","G->D","H->U","I->I","J->J","K->P","L->O","M->E","N->S","O->Q","P->X","Q->L","R->K","S->B","T->F","U->Z","V->W","W->N","X->T","Y->V","Z->M","a->a","b->k","c->g","d->p","e->h","f->w","g->f","h->c","i->m","j->t","k->e","l->b","m->i","n->q","o->l","p->x","q->z","r->s","s->n","t->y","u->d","v->u","w->v","x->r","y->j","z->o"}',
        "22":'{"A->H","B->R","C->A","D->Y","E->G","F->C","G->D","H->U","I->I","J->J","K->P","L->O","M->E","N->S","O->Q","P->X","Q->L","R->K","S->B","T->F","U->Z","V->W","W->N","X->T","Y->V","Z->M","a->a","b->k","c->g","d->p","e->h","f->w","g->f","h->c","i->m","j->t","k->e","l->b","m->i","n->q","o->l","p->x","q->z","r->s","s->n","t->y","u->d","v->u","w->v","x->r","y->j","z->o"}',
      },
      formatMap2:{
        "1":{
          "A":"F","B":"X","C":"K","D":"S","E":"Y","F":"R","G":"U","H":"M","I":"P","J":"N","K":"Z","L":"B","M":"C","N":"E","O":"Q","P":"I","Q":"W","R":"O","S":"V","T":"G","U":"A","V":"J","W":"L","X":"H","Y":"D","Z":"T","a":"r","b":"f","c":"k","d":"p","e":"j","f":"m","g":"x","h":"v","i":"l","j":"h","k":"o","l":"q","m":"y","n":"z","o":"e","p":"g","q":"w","r":"d","s":"c","t":"a","u":"u","v":"b","w":"i","x":"t","y":"s","z":"n"
        },
        "2":{
          "F":"A","X":"B","K":"C","S":"D","Y":"E","R":"F","U":"G","M":"H","P":"I","N":"J","Z":"K","B":"L","C":"M","E":"N","Q":"O","I":"P","W":"Q","O":"R","V":"S","G":"T","A":"U","J":"V","L":"W","H":"X","D":"Y","T":"Z","r":"a","f":"b","k":"c","p":"d","j":"e","m":"f","x":"g","v":"h","l":"i","h":"j","o":"k","q":"l","y":"m","z":"n","e":"o","g":"p","w":"q","d":"r","c":"s","a":"t","u":"u","b":"v","i":"w","t":"x","s":"y","n":"z"
        },
        "3":{
          "A":"H","B":"P","C":"F","D":"W","E":"J","F":"G","G":"Q","H":"V","I":"U","J":"T","K":"Y","L":"I","M":"C","N":"S","O":"M","P":"O","Q":"K","R":"R","S":"Z","T":"D","U":"X","V":"B","W":"L","X":"E","Y":"N","Z":"A","a":"j","b":"b","c":"s","d":"q","e":"x","f":"l","g":"d","h":"m","i":"i","j":"u","k":"n","l":"h","m":"k","n":"f","o":"y","p":"v","q":"a","r":"t","s":"z","t":"w","u":"e","v":"o","w":"c","x":"g","y":"p","z":"r"
        },
        "4":{
          "H":"A","P":"B","F":"C","W":"D","J":"E","G":"F","Q":"G","V":"H","U":"I","T":"J","Y":"K","I":"L","C":"M","S":"N","M":"O","O":"P","K":"Q","R":"R","Z":"S","D":"T","X":"U","B":"V","L":"W","E":"X","N":"Y","A":"Z","j":"a","b":"b","s":"c","q":"d","x":"e","l":"f","d":"g","m":"h","i":"i","u":"j","n":"k","h":"l","k":"m","f":"n","y":"o","v":"p","a":"q","t":"r","z":"s","w":"t","e":"u","o":"v","c":"w","g":"x","p":"y","r":"z"
        },
        "5":'{"A->D","B->O","C->E","D->S","E->B","F->I","G->R","H->H","I->F","J->T","K->C","L->X","M->P","N->Y","O->U","P->L","Q->V","R->M","S->Z","T->N","U->A","V->J","W->W","X->K","Y->Q","Z->G","a->d","b->a","c->j","d->m","e->i","f->f","g->e","h->r","i->c","j->w","k->l","l->o","m->b","n->s","o->k","p->q","q->n","r->z","s->v","t->g","u->h","v->y","w->p","x->t","y->x","z->u"}',
        "6":'{"A->D","B->O","C->E","D->S","E->B","F->I","G->R","H->H","I->F","J->T","K->C","L->X","M->P","N->Y","O->U","P->L","Q->V","R->M","S->Z","T->N","U->A","V->J","W->W","X->K","Y->Q","Z->G","a->d","b->a","c->j","d->m","e->i","f->f","g->e","h->r","i->c","j->w","k->l","l->o","m->b","n->s","o->k","p->q","q->n","r->z","s->v","t->g","u->h","v->y","w->p","x->t","y->x","z->u"}',
        "7":'{"A->I","B->Y","C->T","D->P","E->L","F->V","G->R","H->U","I->B","J->O","K->A","L->D","M->S","N->H","O->W","P->C","Q->M","R->G","S->E","T->K","U->Z","V->X","W->N","X->F","Y->J","Z->Q","a->s","b->d","c->u","d->t","e->o","f->p","g->l","h->k","i->m","j->v","k->h","l->g","m->n","n->i","o->j","p->x","q->q","r->w","s->b","t->c","u->z","v->a","w->f","x->r","y->e","z->y"}',
        "8":'{"A->I","B->Y","C->T","D->P","E->L","F->V","G->R","H->U","I->B","J->O","K->A","L->D","M->S","N->H","O->W","P->C","Q->M","R->G","S->E","T->K","U->Z","V->X","W->N","X->F","Y->J","Z->Q","a->s","b->d","c->u","d->t","e->o","f->p","g->l","h->k","i->m","j->v","k->h","l->g","m->n","n->i","o->j","p->x","q->q","r->w","s->b","t->c","u->z","v->a","w->f","x->r","y->e","z->y"}',

      },
      formatMap3:{
        "1":{
          "A":"O","B":"G","C":"F","D":"R","E":"V","F":"L","G":"P","H":"W","I":"B","J":"J","K":"A","L":"M","M":"Z","N":"N","O":"H","P":"K","Q":"S","R":"U","S":"Y","T":"D","U":"T","V":"X","W":"C","X":"Q","Y":"I","Z":"E","a":"d","b":"o","c":"k","d":"z","e":"s","f":"l","g":"p","h":"h","i":"r","j":"a","k":"q","l":"y","m":"g","n":"t","o":"i","p":"e","q":"x","r":"v","s":"b","t":"c","u":"u","v":"f","w":"w","x":"m","y":"n","z":"j"
        },
        "2":{
          "O":"A","G":"B","F":"C","R":"D","V":"E","L":"F","P":"G","W":"H","B":"I","J":"J","A":"K","M":"L","Z":"M","N":"N","H":"O","K":"P","S":"Q","U":"R","Y":"S","D":"T","T":"U","X":"V","C":"W","Q":"X","I":"Y","E":"Z","d":"a","o":"b","k":"c","z":"d","s":"e","l":"f","p":"g","h":"h","r":"i","a":"j","q":"k","y":"l","g":"m","t":"n","i":"o","e":"p","x":"q","v":"r","b":"s","c":"t","u":"u","f":"v","w":"w","m":"x","n":"y","j":"z"
        },
        "3":{
          "A":"V","B":"T","C":"A","D":"N","E":"J","F":"K","G":"Z","H":"E","I":"S","J":"W","K":"C","L":"R","M":"F","N":"O","O":"M","P":"L","Q":"H","R":"B","S":"P","T":"I","U":"G","V":"D","W":"U","X":"Y","Y":"X","Z":"Q","a":"b","b":"r","c":"a","d":"i","e":"q","f":"z","g":"u","h":"n","i":"x","j":"m","k":"g","l":"k","m":"h","n":"v","o":"t","p":"y","q":"c","r":"d","s":"w","t":"s","u":"l","v":"f","w":"o","x":"e","y":"p","z":"j"
        },
        "4":{
          "V":"A","T":"B","A":"C","N":"D","J":"E","K":"F","Z":"G","E":"H","S":"I","W":"J","C":"K","R":"L","F":"M","O":"N","M":"O","L":"P","H":"Q","B":"R","P":"S","I":"T","G":"U","D":"V","U":"W","Y":"X","X":"Y","Q":"Z","b":"a","r":"b","a":"c","i":"d","q":"e","z":"f","u":"g","n":"h","x":"i","m":"j","g":"k","k":"l","h":"m","v":"n","t":"o","y":"p","c":"q","d":"r","w":"s","s":"t","l":"u","f":"v","o":"w","e":"x","p":"y","j":"z"
        },
        "5":{
          "A":"M","B":"R","C":"A","D":"Z","E":"V","F":"K","G":"N","H":"F","I":"I","J":"B","K":"E","L":"U","M":"P","N":"T","O":"D","P":"H","Q":"X","R":"O","S":"C","T":"S","U":"W","V":"J","W":"Y","X":"L","Y":"Q","Z":"G","a":"l","b":"e","c":"d","d":"z","e":"g","f":"f","g":"h","h":"p","i":"w","j":"a","k":"m","l":"y","m":"t","n":"n","o":"j","p":"q","q":"v","r":"u","s":"o","t":"i","u":"c","v":"r","w":"x","x":"s","y":"k","z":"b"
        },
        "6":{
          "M":"A","R":"B","A":"C","Z":"D","V":"E","K":"F","N":"G","F":"H","I":"I","B":"J","E":"K","U":"L","P":"M","T":"N","D":"O","H":"P","X":"Q","O":"R","C":"S","S":"T","W":"U","J":"V","Y":"W","L":"X","Q":"Y","G":"Z","l":"a","e":"b","d":"c","z":"d","g":"e","f":"f","h":"g","p":"h","w":"i","a":"j","m":"k","y":"l","t":"m","n":"n","j":"o","q":"p","v":"q","u":"r","o":"s","i":"t","c":"u","r":"v","x":"w","s":"x","k":"y","b":"z"
        },
        "7":'{"A->W","B->T","C->F","D->I","E->P","F->O","G->C","H->N","I->X","J->V","K->Q","L->G","M->A","N->R","O->D","P->S","Q->L","R->Y","S->B","T->Z","U->H","V->J","W->E","X->M","Y->K","Z->U","a->c","b->b","c->f","d->m","e->p","f->l","g->i","h->d","i->w","j->e","k->o","l->r","m->x","n->v","o->t","p->j","q->z","r->h","s->n","t->u","u->s","v->q","w->a","x->k","y->g","z->y"}',
        "8":'{"A->W","B->T","C->F","D->I","E->P","F->O","G->C","H->N","I->X","J->V","K->Q","L->G","M->A","N->R","O->D","P->S","Q->L","R->Y","S->B","T->Z","U->H","V->J","W->E","X->M","Y->K","Z->U","a->c","b->b","c->f","d->m","e->p","f->l","g->i","h->d","i->w","j->e","k->o","l->r","m->x","n->v","o->t","p->j","q->z","r->h","s->n","t->u","u->s","v->q","w->a","x->k","y->g","z->y"}',
        "9":'{"A->S","B->B","C->X","D->G","E->O","F->Z","G->W","H->D","I->R","J->L","K->Q","L->V","M->C","N->K","O->Y","P->U","Q->F","R->I","S->T","T->P","U->J","V->A","W->H","X->E","Y->M","Z->N","a->v","b->p","c->l","d->b","e->c","f->o","g->q","h->h","i->u","j->x","k->a","l->f","m->m","n->i","o->w","p->z","q->j","r->r","s->y","t->d","u->s","v->t","w->n","x->g","y->k","z->e"}',
        "10":'{"A->S","B->B","C->X","D->G","E->O","F->Z","G->W","H->D","I->R","J->L","K->Q","L->V","M->C","N->K","O->Y","P->U","Q->F","R->I","S->T","T->P","U->J","V->A","W->H","X->E","Y->M","Z->N","a->v","b->p","c->l","d->b","e->c","f->o","g->q","h->h","i->u","j->x","k->a","l->f","m->m","n->i","o->w","p->z","q->j","r->r","s->y","t->d","u->s","v->t","w->n","x->g","y->k","z->e"}',
        "11":'{"A->Q","B->H","C->I","D->O","E->V","F->Z","G->T","H->P","I->R","J->C","K->U","L->S","M->N","N->M","O->D","P->W","Q->K","R->J","S->X","T->F","U->G","V->Y","W->B","X->A","Y->L","Z->E","a->j","b->v","c->s","d->z","e->q","f->k","g->b","h->t","i->n","j->r","k->e","l->w","m->p","n->u","o->i","p->f","q->c","r->d","s->a","t->y","u->m","v->x","w->g","x->h","y->l","z->o"}',
        "12":'{"A->Q","B->H","C->I","D->O","E->V","F->Z","G->T","H->P","I->R","J->C","K->U","L->S","M->N","N->M","O->D","P->W","Q->K","R->J","S->X","T->F","U->G","V->Y","W->B","X->A","Y->L","Z->E","a->j","b->v","c->s","d->z","e->q","f->k","g->b","h->t","i->n","j->r","k->e","l->w","m->p","n->u","o->i","p->f","q->c","r->d","s->a","t->y","u->m","v->x","w->g","x->h","y->l","z->o"}',
        "13":'{"A->Q","B->E","C->A","D->F","E->B","F->S","G->C","H->W","I->I","J->H","K->V","L->O","M->X","N->L","O->P","P->U","Q->D","R->Y","S->R","T->T","U->N","V->Z","W->K","X->J","Y->G","Z->M","a->a","b->f","c->p","d->e","e->y","f->j","g->m","h->v","i->n","j->d","k->i","l->s","m->r","n->z","o->k","p->o","q->l","r->b","s->u","t->q","u->w","v->g","w->t","x->h","y->x","z->c"}',
        "14":'{"A->Q","B->E","C->A","D->F","E->B","F->S","G->C","H->W","I->I","J->H","K->V","L->O","M->X","N->L","O->P","P->U","Q->D","R->Y","S->R","T->T","U->N","V->Z","W->K","X->J","Y->G","Z->M","a->a","b->f","c->p","d->e","e->y","f->j","g->m","h->v","i->n","j->d","k->i","l->s","m->r","n->z","o->k","p->o","q->l","r->b","s->u","t->q","u->w","v->g","w->t","x->h","y->x","z->c"}',
        "15":'{"A->U","B->Y","C->N","D->H","E->E","F->A","G->Z","H->C","I->T","J->Q","K->K","L->S","M->G","N->L","O->P","P->R","Q->J","R->V","S->W","T->M","U->X","V->I","W->B","X->D","Y->F","Z->O","a->b","b->g","c->r","d->i","e->u","f->t","g->z","h->f","i->x","j->j","k->n","l->e","m->v","n->s","o->l","p->d","q->k","r->p","s->w","t->c","u->h","v->a","w->y","x->o","y->m","z->q"}',
        "16":'{"A->U","B->Y","C->N","D->H","E->E","F->A","G->Z","H->C","I->T","J->Q","K->K","L->S","M->G","N->L","O->P","P->R","Q->J","R->V","S->W","T->M","U->X","V->I","W->B","X->D","Y->F","Z->O","a->b","b->g","c->r","d->i","e->u","f->t","g->z","h->f","i->x","j->j","k->n","l->e","m->v","n->s","o->l","p->d","q->k","r->p","s->w","t->c","u->h","v->a","w->y","x->o","y->m","z->q"}',
        "17":'{"A->S","B->A","C->N","D->E","E->M","F->W","G->V","H->O","I->J","J->Z","K->R","L->P","M->C","N->I","O->B","P->L","Q->G","R->F","S->K","T->H","U->Q","V->Y","W->U","X->X","Y->T","Z->D","a->k","b->n","c->o","d->j","e->u","f->f","g->w","h->g","i->c","j->b","k->r","l->x","m->i","n->l","o->t","p->s","q->p","r->z","s->v","t->e","u->a","v->y","w->q","x->d","y->h","z->m"}',
        "18":'{"A->S","B->A","C->N","D->E","E->M","F->W","G->V","H->O","I->J","J->Z","K->R","L->P","M->C","N->I","O->B","P->L","Q->G","R->F","S->K","T->H","U->Q","V->Y","W->U","X->X","Y->T","Z->D","a->k","b->n","c->o","d->j","e->u","f->f","g->w","h->g","i->c","j->b","k->r","l->x","m->i","n->l","o->t","p->s","q->p","r->z","s->v","t->e","u->a","v->y","w->q","x->d","y->h","z->m"}',
        "19":'{"A->M","B->Y","C->G","D->I","E->S","F->O","G->X","H->A","I->T","J->R","K->H","L->D","M->W","N->J","O->N","P->B","Q->K","R->E","S->Z","T->U","U->P","V->C","W->V","X->Q","Y->L","Z->F","a->g","b->o","c->k","d->x","e->c","f->w","g->t","h->l","i->j","j->y","k->q","l->f","m->v","n->d","o->s","p->h","q->p","r->m","s->i","t->a","u->u","v->z","w->b","x->e","y->r","z->n"}',
        "20":'{"A->M","B->Y","C->G","D->I","E->S","F->O","G->X","H->A","I->T","J->R","K->H","L->D","M->W","N->J","O->N","P->B","Q->K","R->E","S->Z","T->U","U->P","V->C","W->V","X->Q","Y->L","Z->F","a->g","b->o","c->k","d->x","e->c","f->w","g->t","h->l","i->j","j->y","k->q","l->f","m->v","n->d","o->s","p->h","q->p","r->m","s->i","t->a","u->u","v->z","w->b","x->e","y->r","z->n"}',
        "21":'{"a->g","b->h","c->i","d->j","e->k","f->l","g->m","h->n","i->o","j->p","k->q","l->r","m->s","n->t","o->u","p->v","q->w","r->x","s->y","t->z","u->a","v->b","w->c","x->d","y->e","z->f","A->G","B->H","C->I","D->J","E->K","F->L","G->M","H->N","I->O","J->P","K->Q","L->R","M->S","N->T","O->U","P->V","Q->W","R->X","S->Y","T->Z","U->A","V->B","W->C","X->D","Y->E","Z->F"}',
        "22":'{"a->g","b->h","c->i","d->j","e->k","f->l","g->m","h->n","i->o","j->p","k->q","l->r","m->s","n->t","o->u","p->v","q->w","r->x","s->y","t->z","u->a","v->b","w->c","x->d","y->e","z->f","A->G","B->H","C->I","D->J","E->K","F->L","G->M","H->N","I->O","J->P","K->Q","L->R","M->S","N->T","O->U","P->V","Q->W","R->X","S->Y","T->Z","U->A","V->B","W->C","X->D","Y->E","Z->F"}',
        "23":'{"a->U","b->v","c->H","d->J","e->W","f->C","g->c","h->S","i->x","j->s","k->b","l->G","m->n","n->I","o->m","p->g","q->a","r->z","s->L","t->E","u->i","v->u","w->X","x->B","y->N","z->p","A->T","B->K","C->F","D->V","E->R","F->f","G->j","H->Z","I->O","J->Y","K->t","L->o","M->e","N->D","O->P","P->d","Q->w","R->Q","S->M","T->l","U->h","V->y","W->A","X->r","Y->q","Z->k"}',
        "24":'{"a->U","b->v","c->H","d->J","e->W","f->C","g->c","h->S","i->x","j->s","k->b","l->G","m->n","n->I","o->m","p->g","q->a","r->z","s->L","t->E","u->i","v->u","w->X","x->B","y->N","z->p","A->T","B->K","C->F","D->V","E->R","F->f","G->j","H->Z","I->O","J->Y","K->t","L->o","M->e","N->D","O->P","P->d","Q->w","R->Q","S->M","T->l","U->h","V->y","W->A","X->r","Y->q","Z->k"}',
        "25":'',
        "26":'',
        "27":'',
        "28":'',
      },
      formatMap4:{
        "1":'{"A->C","B->Q","C->E","D->D","E->K","F->G","G->T","H->A","I->J","J->W","K->V","L->U","M->B","N->Y","O->I","P->M","Q->N","R->F","S->Z","T->H","U->O","V->S","W->X","X->P","Y->L","Z->R","a->q","b->t","c->c","d->y","e->f","f->k","g->z","h->i","i->j","j->v","k->g","l->x","m->l","n->p","o->n","p->w","q->s","r->m","s->u","t->b","u->a","v->r","w->d","x->o","y->e","z->h"}',
        "2":'{"A->C","B->Q","C->E","D->D","E->K","F->G","G->T","H->A","I->J","J->W","K->V","L->U","M->B","N->Y","O->I","P->M","Q->N","R->F","S->Z","T->H","U->O","V->S","W->X","X->P","Y->L","Z->R","a->q","b->t","c->c","d->y","e->f","f->k","g->z","h->i","i->j","j->v","k->g","l->x","m->l","n->p","o->n","p->w","q->s","r->m","s->u","t->b","u->a","v->r","w->d","x->o","y->e","z->h"}',
        "3":'{"A->U","B->F","C->K","D->A","E->C","F->R","G->D","H->E","I->B","J->H","K->Z","L->W","M->P","N->M","O->L","P->I","Q->X","R->N","S->Y","T->S","U->V","V->T","W->O","X->G","Y->Q","Z->J","a->k","b->v","c->n","d->z","e->o","f->l","g->x","h->b","i->f","j->w","k->s","l->i","m->c","n->h","o->r","p->y","q->m","r->j","s->a","t->q","u->t","v->d","w->e","x->g","y->p","z->u"}',
        "4":'{"A->U","B->F","C->K","D->A","E->C","F->R","G->D","H->E","I->B","J->H","K->Z","L->W","M->P","N->M","O->L","P->I","Q->X","R->N","S->Y","T->S","U->V","V->T","W->O","X->G","Y->Q","Z->J","a->k","b->v","c->n","d->z","e->o","f->l","g->x","h->b","i->f","j->w","k->s","l->i","m->c","n->h","o->r","p->y","q->m","r->j","s->a","t->q","u->t","v->d","w->e","x->g","y->p","z->u"}',
        "5":'{"A->O","B->N","C->I","D->M","E->A","F->C","G->D","H->Y","I->G","J->W","K->H","L->K","M->U","N->Q","O->F","P->R","Q->X","R->L","S->B","T->E","U->P","V->S","W->J","X->V","Y->Z","Z->T","a->n","b->c","c->r","d->d","e->k","f->b","g->g","h->h","i->w","j->i","k->t","l->y","m->z","n->l","o->s","p->q","q->e","r->m","s->x","t->o","u->j","v->v","w->f","x->u","y->p","z->a"}',
        "6":'{"A->O","B->N","C->I","D->M","E->A","F->C","G->D","H->Y","I->G","J->W","K->H","L->K","M->U","N->Q","O->F","P->R","Q->X","R->L","S->B","T->E","U->P","V->S","W->J","X->V","Y->Z","Z->T","a->n","b->c","c->r","d->d","e->k","f->b","g->g","h->h","i->w","j->i","k->t","l->y","m->z","n->l","o->s","p->q","q->e","r->m","s->x","t->o","u->j","v->v","w->f","x->u","y->p","z->a"}',
        "7":'{"A->A","B->U","C->L","D->J","E->E","F->F","G->G","H->W","I->O","J->Q","K->Y","L->T","M->D","N->M","O->I","P->P","Q->N","R->S","S->V","T->H","U->C","V->K","W->B","X->X","Y->R","Z->Z","a->f","b->e","c->z","d->h","e->b","f->g","g->x","h->d","i->t","j->o","k->n","l->u","m->c","n->l","o->m","p->y","q->r","r->j","s->k","t->s","u->q","v->a","w->i","x->v","y->w","z->p"}',
        "8":'{"A->A","B->U","C->L","D->J","E->E","F->F","G->G","H->W","I->O","J->Q","K->Y","L->T","M->D","N->M","O->I","P->P","Q->N","R->S","S->V","T->H","U->C","V->K","W->B","X->X","Y->R","Z->Z","a->f","b->e","c->z","d->h","e->b","f->g","g->x","h->d","i->t","j->o","k->n","l->u","m->c","n->l","o->m","p->y","q->r","r->j","s->k","t->s","u->q","v->a","w->i","x->v","y->w","z->p"}',
        "9":'{"A->L","B->W","C->G","D->H","E->K","F->E","G->R","H->A","I->U","J->J","K->Y","L->Z","M->I","N->V","O->C","P->F","Q->M","R->X","S->Q","T->S","U->P","V->D","W->T","X->B","Y->N","Z->O","a->c","b->e","c->d","d->o","e->y","f->f","g->l","h->u","i->r","j->v","k->p","l->z","m->q","n->a","o->h","p->g","q->i","r->b","s->x","t->n","u->s","v->w","w->m","x->k","y->t","z->j"}',
        "10":'{"A->L","B->W","C->G","D->H","E->K","F->E","G->R","H->A","I->U","J->J","K->Y","L->Z","M->I","N->V","O->C","P->F","Q->M","R->X","S->Q","T->S","U->P","V->D","W->T","X->B","Y->N","Z->O","a->c","b->e","c->d","d->o","e->y","f->f","g->l","h->u","i->r","j->v","k->p","l->z","m->q","n->a","o->h","p->g","q->i","r->b","s->x","t->n","u->s","v->w","w->m","x->k","y->t","z->j"}',
        "11":'{"A->J","B->B","C->E","D->X","E->R","F->G","G->D","H->N","I->Y","J->O","K->I","L->V","M->W","N->S","O->H","P->F","Q->L","R->A","S->M","T->Q","U->P","V->T","W->U","X->Z","Y->K","Z->C","a->t","b->d","c->u","d->v","e->w","f->r","g->k","h->n","i->c","j->a","k->j","l->o","m->h","n->i","o->p","p->m","q->q","r->b","s->e","t->g","u->s","v->z","w->l","x->x","y->y","z->f"}',
        "12":'{"A->J","B->B","C->E","D->X","E->R","F->G","G->D","H->N","I->Y","J->O","K->I","L->V","M->W","N->S","O->H","P->F","Q->L","R->A","S->M","T->Q","U->P","V->T","W->U","X->Z","Y->K","Z->C","a->t","b->d","c->u","d->v","e->w","f->r","g->k","h->n","i->c","j->a","k->j","l->o","m->h","n->i","o->p","p->m","q->q","r->b","s->e","t->g","u->s","v->z","w->l","x->x","y->y","z->f"}',
        "13":'{"A->I","B->W","C->H","D->K","E->F","F->Z","G->M","H->C","I->A","J->P","K->Y","L->E","M->N","N->G","O->X","P->B","Q->J","R->S","S->Q","T->R","U->V","V->O","W->T","X->L","Y->U","Z->D","a->z","b->c","c->m","d->f","e->j","f->b","g->s","h->l","i->o","j->v","k->i","l->u","m->h","n->w","o->x","p->q","q->p","r->k","s->d","t->g","u->e","v->t","w->a","x->n","y->r","z->y"}',
        "14":'{"A->I","B->W","C->H","D->K","E->F","F->Z","G->M","H->C","I->A","J->P","K->Y","L->E","M->N","N->G","O->X","P->B","Q->J","R->S","S->Q","T->R","U->V","V->O","W->T","X->L","Y->U","Z->D","a->z","b->c","c->m","d->f","e->j","f->b","g->s","h->l","i->o","j->v","k->i","l->u","m->h","n->w","o->x","p->q","q->p","r->k","s->d","t->g","u->e","v->t","w->a","x->n","y->r","z->y"}',
        "15":'{"A->Q","B->R","C->J","D->X","E->M","F->C","G->Y","H->I","I->S","J->K","K->T","L->L","M->W","N->H","O->P","P->B","Q->O","R->F","S->E","T->A","U->V","V->D","W->U","X->Z","Y->N","Z->G","a->r","b->e","c->s","d->q","e->u","f->c","g->z","h->k","i->f","j->v","k->m","l->p","m->t","n->a","o->b","p->j","q->h","r->i","s->g","t->o","u->y","v->d","w->l","x->x","y->w","z->n"}',
        "16":'{"A->Q","B->R","C->J","D->X","E->M","F->C","G->Y","H->I","I->S","J->K","K->T","L->L","M->W","N->H","O->P","P->B","Q->O","R->F","S->E","T->A","U->V","V->D","W->U","X->Z","Y->N","Z->G","a->r","b->e","c->s","d->q","e->u","f->c","g->z","h->k","i->f","j->v","k->m","l->p","m->t","n->a","o->b","p->j","q->h","r->i","s->g","t->o","u->y","v->d","w->l","x->x","y->w","z->n"}',
        "17":'{"A->T","B->Q","C->Z","D->B","E->J","F->A","G->C","H->R","I->X","J->L","K->E","L->P","M->S","N->M","O->F","P->G","Q->H","R->O","S->W","T->D","U->U","V->N","W->V","X->K","Y->I","Z->Y","a->s","b->v","c->c","d->a","e->i","f->k","g->p","h->q","i->x","j->z","k->n","l->e","m->t","n->b","o->d","p->l","q->g","r->w","s->j","t->h","u->m","v->r","w->o","x->y","y->u","z->f"}',
        "18":'{"A->T","B->Q","C->Z","D->B","E->J","F->A","G->C","H->R","I->X","J->L","K->E","L->P","M->S","N->M","O->F","P->G","Q->H","R->O","S->W","T->D","U->U","V->N","W->V","X->K","Y->I","Z->Y","a->s","b->v","c->c","d->a","e->i","f->k","g->p","h->q","i->x","j->z","k->n","l->e","m->t","n->b","o->d","p->l","q->g","r->w","s->j","t->h","u->m","v->r","w->o","x->y","y->u","z->f"}',
        "19":'{"A->M","B->T","C->P","D->R","E->Q","F->I","G->N","H->B","I->X","J->G","K->D","L->H","M->J","N->Z","O->V","P->W","Q->E","R->F","S->A","T->L","U->U","V->C","W->S","X->O","Y->Y","Z->K","a->j","b->c","c->y","d->v","e->h","f->o","g->e","h->f","i->q","j->k","k->w","l->m","m->g","n->n","o->x","p->d","q->l","r->u","s->t","t->b","u->s","v->r","w->i","x->z","y->p","z->a"}',
        "20":'{"A->M","B->T","C->P","D->R","E->Q","F->I","G->N","H->B","I->X","J->G","K->D","L->H","M->J","N->Z","O->V","P->W","Q->E","R->F","S->A","T->L","U->U","V->C","W->S","X->O","Y->Y","Z->K","a->j","b->c","c->y","d->v","e->h","f->o","g->e","h->f","i->q","j->k","k->w","l->m","m->g","n->n","o->x","p->d","q->l","r->u","s->t","t->b","u->s","v->r","w->i","x->z","y->p","z->a"}',
        "21":'{"A->Q","B->J","C->S","D->M","E->G","F->E","G->P","H->W","I->A","J->U","K->I","L->Z","M->X","N->L","O->T","P->N","Q->B","R->V","S->F","T->O","U->R","V->C","W->K","X->Y","Y->D","Z->H","a->u","b->c","c->x","d->j","e->v","f->y","g->d","h->k","i->z","j->p","k->w","l->t","m->a","n->n","o->f","p->l","q->o","r->e","s->i","t->m","u->g","v->q","w->r","x->s","y->h","z->b"}',
        "22":'{"A->Q","B->J","C->S","D->M","E->G","F->E","G->P","H->W","I->A","J->U","K->I","L->Z","M->X","N->L","O->T","P->N","Q->B","R->V","S->F","T->O","U->R","V->C","W->K","X->Y","Y->D","Z->H","a->u","b->c","c->x","d->j","e->v","f->y","g->d","h->k","i->z","j->p","k->w","l->t","m->a","n->n","o->f","p->l","q->o","r->e","s->i","t->m","u->g","v->q","w->r","x->s","y->h","z->b"}',
        "23":'{"A->E","B->B","C->X","D->I","E->Y","F->U","G->O","H->L","I->S","J->F","K->V","L->P","M->Q","N->M","O->Z","P->C","Q->A","R->D","S->T","T->N","U->J","V->K","W->G","X->H","Y->W","Z->R","a->j","b->v","c->y","d->d","e->n","f->l","g->c","h->q","i->t","j->u","k->k","l->r","m->p","n->z","o->w","p->m","q->e","r->o","s->x","t->a","u->h","v->f","w->s","x->i","y->g","z->b"}',
        "24":'{"A->E","B->B","C->X","D->I","E->Y","F->U","G->O","H->L","I->S","J->F","K->V","L->P","M->Q","N->M","O->Z","P->C","Q->A","R->D","S->T","T->N","U->J","V->K","W->G","X->H","Y->W","Z->R","a->j","b->v","c->y","d->d","e->n","f->l","g->c","h->q","i->t","j->u","k->k","l->r","m->p","n->z","o->w","p->m","q->e","r->o","s->x","t->a","u->h","v->f","w->s","x->i","y->g","z->b"}',
        "25":'{"A->I","B->P","C->X","D->Y","E->U","F->Q","G->L","H->B","I->S","J->J","K->G","L->T","M->H","N->C","O->V","P->F","Q->N","R->A","S->E","T->Z","U->K","V->D","W->W","X->R","Y->O","Z->M","a->g","b->m","c->v","d->z","e->u","f->r","g->t","h->h","i->b","j->y","k->d","l->e","m->q","n->a","o->f","p->p","q->k","r->l","s->j","t->w","u->i","v->s","w->x","x->n","y->o","z->c"}',
        "26":'{"A->I","B->P","C->X","D->Y","E->U","F->Q","G->L","H->B","I->S","J->J","K->G","L->T","M->H","N->C","O->V","P->F","Q->N","R->A","S->E","T->Z","U->K","V->D","W->W","X->R","Y->O","Z->M","a->g","b->m","c->v","d->z","e->u","f->r","g->t","h->h","i->b","j->y","k->d","l->e","m->q","n->a","o->f","p->p","q->k","r->l","s->j","t->w","u->i","v->s","w->x","x->n","y->o","z->c"}',
        "27":'{"A->L","B->K","C->M","D->R","E->S","F->F","G->X","H->Q","I->Y","J->N","K->U","L->P","M->W","N->E","O->Z","P->V","Q->O","R->J","S->G","T->D","U->C","V->B","W->I","X->T","Y->A","Z->H","a->j","b->v","c->o","d->w","e->c","f->e","g->r","h->p","i->y","j->g","k->u","l->m","m->k","n->n","o->f","p->h","q->s","r->l","s->b","t->t","u->d","v->q","w->i","x->z","y->x","z->a"}',
        "28":'{"A->L","B->K","C->M","D->R","E->S","F->F","G->X","H->Q","I->Y","J->N","K->U","L->P","M->W","N->E","O->Z","P->V","Q->O","R->J","S->G","T->D","U->C","V->B","W->I","X->T","Y->A","Z->H","a->j","b->v","c->o","d->w","e->c","f->e","g->r","h->p","i->y","j->g","k->u","l->m","m->k","n->n","o->f","p->h","q->s","r->l","s->b","t->t","u->d","v->q","w->i","x->z","y->x","z->a"}',
        "29":'{"A->P","B->G","C->M","D->L","E->Z","F->H","G->R","H->A","I->N","J->Y","K->X","L->K","M->V","N->B","O->S","P->Q","Q->C","R->T","S->U","T->J","U->E","V->W","W->D","X->I","Y->F","Z->O","a->m","b->a","c->j","d->i","e->v","f->c","g->k","h->r","i->z","j->w","k->q","l->e","m->f","n->t","o->b","p->d","q->u","r->g","s->p","t->o","u->y","v->n","w->x","x->h","y->s","z->l"}',
        "30":'{"A->P","B->G","C->M","D->L","E->Z","F->H","G->R","H->A","I->N","J->Y","K->X","L->K","M->V","N->B","O->S","P->Q","Q->C","R->T","S->U","T->J","U->E","V->W","W->D","X->I","Y->F","Z->O","a->m","b->a","c->j","d->i","e->v","f->c","g->k","h->r","i->z","j->w","k->q","l->e","m->f","n->t","o->b","p->d","q->u","r->g","s->p","t->o","u->y","v->n","w->x","x->h","y->s","z->l"}',
        "31":'{"A->L","B->G","C->E","D->J","E->H","F->U","G->W","H->P","I->O","J->V","K->B","L->F","M->Q","N->M","O->Y","P->S","Q->X","R->Z","S->C","T->R","U->I","V->T","W->N","X->A","Y->D","Z->K","a->h","b->l","c->s","d->q","e->n","f->d","g->t","h->m","i->z","j->f","k->b","l->p","m->i","n->x","o->v","p->r","q->k","r->g","s->a","t->y","u->o","v->e","w->j","x->c","y->u","z->w"}',
        "32":'{"A->L","B->G","C->E","D->J","E->H","F->U","G->W","H->P","I->O","J->V","K->B","L->F","M->Q","N->M","O->Y","P->S","Q->X","R->Z","S->C","T->R","U->I","V->T","W->N","X->A","Y->D","Z->K","a->h","b->l","c->s","d->q","e->n","f->d","g->t","h->m","i->z","j->f","k->b","l->p","m->i","n->x","o->v","p->r","q->k","r->g","s->a","t->y","u->o","v->e","w->j","x->c","y->u","z->w"}',
        "33":'{"A->N","B->Y","C->W","D->G","E->F","F->L","G->V","H->Q","I->K","J->R","K->U","L->O","M->D","N->H","O->I","P->J","Q->C","R->S","S->E","T->Z","U->A","V->B","W->X","X->M","Y->P","Z->T","a->g","b->t","c->u","d->h","e->c","f->n","g->e","h->f","i->w","j->z","k->d","l->j","m->k","n->q","o->i","p->y","q->s","r->b","s->r","t->m","u->p","v->x","w->o","x->a","y->v","z->l"}',
        "34":'{"A->N","B->Y","C->W","D->G","E->F","F->L","G->V","H->Q","I->K","J->R","K->U","L->O","M->D","N->H","O->I","P->J","Q->C","R->S","S->E","T->Z","U->A","V->B","W->X","X->M","Y->P","Z->T","a->g","b->t","c->u","d->h","e->c","f->n","g->e","h->f","i->w","j->z","k->d","l->j","m->k","n->q","o->i","p->y","q->s","r->b","s->r","t->m","u->p","v->x","w->o","x->a","y->v","z->l"}',
        "35":'{"A->J","B->B","C->E","D->X","E->R","F->G","G->D","H->N","I->Y","J->O","K->I","L->V","M->W","N->S","O->H","P->F","Q->L","R->A","S->M","T->Q","U->P","V->T","W->U","X->Z","Y->K","Z->C","a->t","b->d","c->u","d->v","e->w","f->r","g->k","h->n","i->c","j->a","k->j","l->o","m->h","n->i","o->p","p->m","q->q","r->b","s->e","t->g","u->s","v->z","w->l","x->x","y->y","z->f"}',
        "36":'{"A->J","B->B","C->E","D->X","E->R","F->G","G->D","H->N","I->Y","J->O","K->I","L->V","M->W","N->S","O->H","P->F","Q->L","R->A","S->M","T->Q","U->P","V->T","W->U","X->Z","Y->K","Z->C","a->t","b->d","c->u","d->v","e->w","f->r","g->k","h->n","i->c","j->a","k->j","l->o","m->h","n->i","o->p","p->m","q->q","r->b","s->e","t->g","u->s","v->z","w->l","x->x","y->y","z->f"}',
        "37":'{"A->P","B->T","C->H","D->E","E->F","F->C","G->R","H->W","I->V","J->Q","K->B","L->S","M->X","N->D","O->U","P->N","Q->G","R->L","S->Z","T->K","U->A","V->O","W->Y","X->M","Y->J","Z->I","a->u","b->q","c->p","d->s","e->y","f->a","g->f","h->r","i->g","j->h","k->d","l->z","m->v","n->k","o->x","p->w","q->c","r->o","s->e","t->n","u->l","v->t","w->i","x->m","y->j","z->b"}',
        "38":'{"A->P","B->T","C->H","D->E","E->F","F->C","G->R","H->W","I->V","J->Q","K->B","L->S","M->X","N->D","O->U","P->N","Q->G","R->L","S->Z","T->K","U->A","V->O","W->Y","X->M","Y->J","Z->I","a->u","b->q","c->p","d->s","e->y","f->a","g->f","h->r","i->g","j->h","k->d","l->z","m->v","n->k","o->x","p->w","q->c","r->o","s->e","t->n","u->l","v->t","w->i","x->m","y->j","z->b"}',
        "39":'',
        "40":'',
      },
      formatMap5:{
        "1":'{"A->T","B->P","C->K","D->U","E->I","F->B","G->Q","H->O","I->H","J->A","K->D","L->V","M->Z","N->M","O->J","P->R","Q->S","R->Y","S->E","T->G","U->X","V->W","W->N","X->C","Y->L","Z->F","a->v","b->q","c->y","d->o","e->g","f->n","g->j","h->d","i->w","j->k","k->a","l->f","m->m","n->p","o->r","p->x","q->z","r->l","s->u","t->h","u->b","v->i","w->t","x->s","y->e","z->c"}',
        "2":'{"A->T","B->P","C->K","D->U","E->I","F->B","G->Q","H->O","I->H","J->A","K->D","L->V","M->Z","N->M","O->J","P->R","Q->S","R->Y","S->E","T->G","U->X","V->W","W->N","X->C","Y->L","Z->F","a->v","b->q","c->y","d->o","e->g","f->n","g->j","h->d","i->w","j->k","k->a","l->f","m->m","n->p","o->r","p->x","q->z","r->l","s->u","t->h","u->b","v->i","w->t","x->s","y->e","z->c"}',
        "3":'{"a->A","b->N","c->l","d->I","e->F","f->X","g->f","h->R","i->M","j->V","k->g","l->b","m->T","n->W","o->P","p->e","q->Y","r->w","s->n","t->i","u->a","v->t","w->x","x->B","y->h","z->L","A->m","B->Q","C->Z","D->y","E->p","F->E","G->q","H->d","I->U","J->r","K->K","L->k","M->c","N->G","O->J","P->j","Q->v","R->S","S->H","T->C","U->s","V->o","W->z","X->O","Y->u","Z->D"}',
        "4":'{"a->A","b->N","c->l","d->I","e->F","f->X","g->f","h->R","i->M","j->V","k->g","l->b","m->T","n->W","o->P","p->e","q->Y","r->w","s->n","t->i","u->a","v->t","w->x","x->B","y->h","z->L","A->m","B->Q","C->Z","D->y","E->p","F->E","G->q","H->d","I->U","J->r","K->K","L->k","M->c","N->G","O->J","P->j","Q->v","R->S","S->H","T->C","U->s","V->o","W->z","X->O","Y->u","Z->D"}',
        "5":'{"a->g","b->C","c->T","d->d","e->I","f->K","g->q","h->v","i->X","j->N","k->k","l->u","m->s","n->O","o->t","p->Q","q->W","r->D","s->n","t->h","u->B","v->e","w->m","x->U","y->r","z->Z","A->p","B->j","C->o","D->F","E->L","F->E","G->S","H->R","I->l","J->i","K->M","L->A","M->b","N->y","O->a","P->f","Q->Y","R->x","S->G","T->V","U->c","V->J","W->H","X->z","Y->w","Z->P"}',
        "6":'{"a->g","b->C","c->T","d->d","e->I","f->K","g->q","h->v","i->X","j->N","k->k","l->u","m->s","n->O","o->t","p->Q","q->W","r->D","s->n","t->h","u->B","v->e","w->m","x->U","y->r","z->Z","A->p","B->j","C->o","D->F","E->L","F->E","G->S","H->R","I->l","J->i","K->M","L->A","M->b","N->y","O->a","P->f","Q->Y","R->x","S->G","T->V","U->c","V->J","W->H","X->z","Y->w","Z->P"}',
        "7":'{"a->c","b->x","c->N","d->l","e->E","f->i","g->j","h->s","i->p","j->C","k->y","l->O","m->m","n->I","o->v","p->A","q->F","r->Q","s->D","t->a","u->q","v->K","w->G","x->T","y->R","z->g","A->d","B->o","C->e","D->z","E->h","F->n","G->r","H->u","I->Y","J->H","K->Z","L->X","M->W","N->S","O->w","P->U","Q->t","R->V","S->b","T->M","U->k","V->B","W->L","X->J","Y->P","Z->f"}',
        "8":'{"a->c","b->x","c->N","d->l","e->E","f->i","g->j","h->s","i->p","j->C","k->y","l->O","m->m","n->I","o->v","p->A","q->F","r->Q","s->D","t->a","u->q","v->K","w->G","x->T","y->R","z->g","A->d","B->o","C->e","D->z","E->h","F->n","G->r","H->u","I->Y","J->H","K->Z","L->X","M->W","N->S","O->w","P->U","Q->t","R->V","S->b","T->M","U->k","V->B","W->L","X->J","Y->P","Z->f"}',
        "9":'{"a->b","b->X","c->o","d->g","e->O","f->G","g->p","h->q","i->a","j->C","k->M","l->R","m->P","n->U","o->Y","p->n","q->k","r->i","s->w","t->v","u->u","v->D","w->K","x->V","y->t","z->T","A->N","B->l","C->S","D->B","E->z","F->d","G->L","H->A","I->f","J->H","K->x","L->j","M->F","N->e","O->r","P->s","Q->h","R->E","S->W","T->J","U->Q","V->m","W->c","X->y","Y->Z","Z->I"}',
        "10":'{"a->b","b->X","c->o","d->g","e->O","f->G","g->p","h->q","i->a","j->C","k->M","l->R","m->P","n->U","o->Y","p->n","q->k","r->i","s->w","t->v","u->u","v->D","w->K","x->V","y->t","z->T","A->N","B->l","C->S","D->B","E->z","F->d","G->L","H->A","I->f","J->H","K->x","L->j","M->F","N->e","O->r","P->s","Q->h","R->E","S->W","T->J","U->Q","V->m","W->c","X->y","Y->Z","Z->I"}',
        "11":'{"a->E","b->N","c->Z","d->y","e->i","f->S","g->A","h->p","i->B","j->P","k->H","l->k","m->C","n->w","o->x","p->n","q->f","r->s","s->z","t->J","u->q","v->D","w->j","x->M","y->o","z->d","A->G","B->u","C->a","D->R","E->r","F->K","G->c","H->X","I->e","J->b","K->F","L->U","M->V","N->Y","O->T","P->I","Q->l","R->g","S->Q","T->h","U->W","V->O","W->v","X->m","Y->L","Z->t"}',
        "12":'{"a->E","b->N","c->Z","d->y","e->i","f->S","g->A","h->p","i->B","j->P","k->H","l->k","m->C","n->w","o->x","p->n","q->f","r->s","s->z","t->J","u->q","v->D","w->j","x->M","y->o","z->d","A->G","B->u","C->a","D->R","E->r","F->K","G->c","H->X","I->e","J->b","K->F","L->U","M->V","N->Y","O->T","P->I","Q->l","R->g","S->Q","T->h","U->W","V->O","W->v","X->m","Y->L","Z->t"}',
        "13":'',
        "14":'',
        "15":'',
        "16":'',
        "17":'',
        "18":'',
      },
      formInline: {
        region: '1',
        plan: '1'
      }
    }
  },
  computed:{
    
  },
  created(){
    this.reqFormat = this.formatMap1['1']
    this.options = this.options1
  },
  methods:{
    getOptionsItem(){
      let item = {}
      if(!this.options || !this.options.length){
        return item
      }
      for (let index = 0; index < this.options.length; index++) {
        const element = this.options[index];
        if(element.value == this.formInline.plan){
          item = JSON.parse(JSON.stringify(element))
          break
        }
      }
      return item
    },
    regionOnChange(){
      this.options = this[`options${this.formInline.region}`]
      this.formInline.plan = '1'
    },
    reqToMapJson(){
      let itemObj  = this.getOptionsItem()
      //新算法判断
      if(!itemObj.reverse){
        this.formatOld()
      }else{
        //新算法
        this.formatNews(itemObj.reverse)
      }
    },
    formatNews(reverse){
      let mapStr = this[`formatMap${this.formInline.region}`][this.formInline.plan]
      let map = this.parseMapNews(mapStr)
      if(reverse == 2){
        this.reqFormat = Object.fromEntries(Object.entries(map).map(([k, v]) => [v, k]));
      }else{
        this.reqFormat = map
      }
      this.formatByMap()
    },
    formatOld(){
      console.log("formatOld")
      this.reqFormat = this[`formatMap${this.formInline.region}`][this.formInline.plan]
      this.formatByMap()
    },
    formatByMap(){
      var map = {}
      if(this.isValidJSON(this.textareaReqParams)){
        map = JSON.parse(this.textareaReqParams)
      }else{
        map = this.strArrToMap(this.textareaReqParams)
      }
      var that = this

      var newMap = this.traverseNew(map, function(key){
        return that.getReqFormatStr(key)
      })
      this.jsonDataReqBefore = map
      this.jsonDataReq = newMap
    },
    parseMapNews(str) {
        const regex = /"(.+?)->(.+?)"/g;
        const map = {};
        let match;
        while ((match = regex.exec(str)) !== null) {
          map[match[1]] = match[2];
        }
        return map;
    },
    getReqFormatStr(str){
      var resStr = str.trim()
      let strArr = [];
      for (const char of resStr) {
        let isSet = false
        for (const key in  this.reqFormat) {
          if (Object.prototype.hasOwnProperty.call(this.reqFormat, key)) {
            const value =  this.reqFormat[key];
            if(key === char){
              isSet = true
              strArr.push(value)
              break
            }
          }
        }
        if(!isSet){
          strArr.push(char)
        }
      }
      return strArr.join("")
    },
    strArrToMap(str){
      if(!str){
        return {}
      }
      const paramsList = this.textareaReqParams.split(/\n/);
      if(!paramsList || paramsList.length == 0){
        return {}
      }
      var map = {}
      paramsList.forEach((item)=>{
        if(item){
          map[item] = item
        }
      })
      return map
    },
    isValidJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    traverseNew(obj,replacer) {
      var newObj = {}
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (Array.isArray(obj[key])) {
            let list = []
            for (let i = 0; i < obj[key].length; i++) {
              if (typeof obj[key][i] === 'object' && obj[key][i] !== null) {
                list.push(this.traverseNew(obj[key][i], replacer))
              }
            }
            newObj[replacer(key)] = list;
          } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            newObj[replacer(key)] = this.traverseNew(obj[key],replacer);
          } else {
            newObj[replacer(key)] = obj[key];
          }
        }
      }
      return newObj;
    },
    //key value 换方向
    reverseObject(obj) {
      const reversed = {};
      for (const [key, value] of Object.entries(obj)) {
        reversed[value] = key;
      }
      return reversed;
    }

  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,body{
  font-family:Arial,Helvetica,sans-serif;
  color: #333;
  font-size: 14px;
}
</style>
